import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import API from "../../services/api";
import "./DeliveryRegister.css";
import OTPInput from "../../components/common/OTPInput/OTPInput";
import PasswordInput from "../../components/common/PasswordInput/PasswordInput";
function DeliveryRegister() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    referralCode: "",
    otp: "",
    password: "",
    confirmPassword: "",
   
  });

  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // ===============================
  // Handle Input Change
  // ===============================

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // ===============================
  // Send OTP
  // ===============================

  const handleSendOTP = async () => {

    try {

        if (!formData.fullName.trim()) {
            alert("Please enter your full name.");
            return;
        }

        if (!formData.email.trim()) {
            alert("Please enter your email.");
            return;
        }

        if (!formData.phone.trim()) {
            alert("Please enter your mobile number.");
            return;
        }

       

        setLoading(true);

        const response = await API.post(
            "/auth/send-email-otp",
            {
                email: formData.email
            }
        );

        if (response.data.success) {

            alert(response.data.message);

            setOtpSent(true);
            console.log("OTP Sent State Updated");

            setCountdown(30);

        }

    }

    catch (error) {

        console.log(error);

        alert(

            error.response?.data?.message ||

            "Failed to send OTP."

        );

    }

    finally {

        setLoading(false);

    }

};
  // ===============================
  // Verify OTP
  // ===============================

  const handleVerifyOTP = async () => {

    try {

        if (formData.otp.length !== 6) {

            alert("Please enter a valid 6-digit OTP.");

            return;

        }

        setLoading(true);

       const response = await API.post(
    "/auth/send-email-otp",
    {
        email: formData.email,
        partnerName: formData.fullName,
        type: "delivery-register",
    }
);

        if (response.data.success) {

            alert(response.data.message);

            setOtpVerified(true);

        }

    }

    catch (error) {

        console.log(error);

        alert(

            error.response?.data?.message ||

            "OTP Verification Failed."

        );

    }

    finally {

        setLoading(false);

    }

};

  // ===============================
  // Register
  // ===============================

 const handleRegister = async () => {

    try {

        if (!formData.password) {

            alert("Please enter password.");

            return;

        }

        if (formData.password.length < 6) {

            alert("Password must be at least 6 characters.");

            return;

        }

        if (formData.password !== formData.confirmPassword) {

            alert("Passwords do not match.");

            return;

        }

        setLoading(true);

        const response = await API.post(

            "/auth/register",

            {

                name: formData.fullName,

                email: formData.email,

                phone: formData.phone,

                password: formData.password,

                role: "delivery"

            }

        );

        if (response.data.success) {

            localStorage.setItem(

                "token",

                response.data.token

            );

            localStorage.setItem(

                "user",

                JSON.stringify(response.data.user)

            );

            alert("Registration Successful");

            // Navigate to Complete Profile page
             navigate("/delivery/complete-profile");

        }

    }

    catch (error) {

        console.log(error);

        alert(

            error.response?.data?.message ||

            "Registration Failed."

        );

    }

    finally {

        setLoading(false);

    }

};

  // ===============================
  // Countdown Timer
  // ===============================

  useEffect(() => {
    let timer;

    if (otpSent && countdown > 0) {
      timer = setTimeout(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    }

    return () => clearTimeout(timer);
  }, [otpSent, countdown]);


  console.log("otpSent:", otpSent);
console.log("otpVerified:", otpVerified);

  return (
    <div className="delivery-register-page">

      <div className="delivery-register-card">

        <div className="delivery-logo">
          🚚
        </div>

        <h1 className="delivery-title">
          HomeFoods
        </h1>

        <h2 className="delivery-subtitle">
          Become a Delivery Partner
        </h2>

        <p className="delivery-description">
          Deliver delicious homemade food and earn every day with HomeFoods.
        </p>

        <form className="delivery-form">

          {/* Full Name */}

          <div className="form-group">

            <label>Full Name</label>

            <input
              type="text"
              name="fullName"
              placeholder="Enter your full name"
              value={formData.fullName}
              onChange={handleChange}
            />

          </div>

            {/* Mobile */}

          <div className="form-group">

            <label>Mobile Number</label>

            <input
              type="tel"
              name="phone"
              placeholder="Enter mobile number"
              value={formData.phone}
              onChange={handleChange}
            />

          </div>


          {/* Email */}

          <div className="form-group">

            <label>Email Address</label>

            <div className="email-row">

              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                disabled={otpSent}
              />

              {!otpSent && (
                <button
                  type="button"
                  className="otp-btn"
                  onClick={handleSendOTP}
                >
                  Send OTP
                </button>
              )}

            </div>

          </div>
           {/* ===========================
              OTP Section
          ============================ */}

          {otpSent && !otpVerified && (

            <>

              <div className="form-group">

                <label>Email OTP</label>

               <OTPInput
  value={formData.otp}
  onChange={(otp) =>
    setFormData((prev) => ({
      ...prev,
      otp,
    }))
  }
/>

              </div>

              <div className="otp-footer">

                {
                  countdown > 0 ? (
                    <span>
                      Resend OTP in {countdown}s
                    </span>
                  ) : (
                    <button
                      type="button"
                      className="resend-btn"
                      onClick={handleSendOTP}
                    >
                      Resend OTP
                    </button>
                  )
                }

              </div>

              <button
                type="button"
                className="delivery-btn"
                onClick={handleVerifyOTP}
              >
                Verify OTP
              </button>

            </>

          )}

        

          {/* ===========================
              Password Section
          ============================ */}

          {otpVerified && (

            <>

              <div className="success-message">
                ✅ Email verified successfully.
              </div>

              <div className="form-group">

                <label>Password</label>

               <PasswordInput
    label="Password"
    name="password"
    value={formData.password}
    placeholder="Create Password"
    onChange={handleChange}
/>

              </div>

              <div className="form-group">

                <label>Confirm Password</label>

                <PasswordInput
    label="Confirm Password"
    name="confirmPassword"
    value={formData.confirmPassword}
    placeholder="Confirm Password"
    onChange={handleChange}
/>

              </div>
               {/* Referral */}

          <div className="form-group">

            <label>Referral Code (Optional)</label>

            <input
              type="text"
              name="referralCode"
              placeholder="Enter referral code"
              value={formData.referralCode}
              onChange={handleChange}
            />

          </div>

          {/* Terms */}

          <div className="terms-section">

            <input
              type="checkbox"
              name="agreeTerms"
              checked={formData.agreeTerms}
              onChange={handleChange}
            />

            <span>
              I agree to the Terms & Conditions
            </span>

          </div>

              <button
                type="button"
                className="delivery-btn"
                onClick={handleRegister}
                disabled={loading}
              >
                {loading ? "Registering..." : "Register"}
              </button>

            </>

          )}
                  </form>

        {/* ===========================
            Login
        ============================ */}

        <div className="delivery-login">

          Already have an account?{" "}

          <Link to="/login">
            Login
          </Link>

        </div>

      </div>

    </div>
  );
}

export default DeliveryRegister;